module.exports = __webpack_public_path__ + "static/media/kneehyperextension_mild_left.1293853e.png";